import { useCMSPageField } from '@/cms/fields'

export interface AccommodationContext {
  accoId: string
  contextItemId: string
  bookingGateId: string
  image: string
  name: string
  alertServiceDataSourceId: string
  promotedPriceId: string
}

export function useAccommodationContext(): AccommodationContext {
  const accommodationId = useCMSPageField('PDP.id')
  const productId = useCMSPageField('PDP.productId')
  const name = useCMSPageField('PDP.title')
  const images = useCMSPageField('PDP.media')
  const bookingGateId = useCMSPageField('PDP.bookingGateId')
  const promotedPriceId = useCMSPageField('PDP.promotedPriceId')
  const priceAlertDatasourceId = useCMSPageField('PDP.pricetable.priceAlertDatasourceId')

  return {
    contextItemId: accommodationId,
    accoId: String(productId),
    name,
    image: images[0]?.src,
    bookingGateId,
    alertServiceDataSourceId: priceAlertDatasourceId,
    promotedPriceId,
  }
}
